export default "__VITE_ASSET__BzZqJz5h__"